import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import logo from '../../assets/images/Tata_motors_JLR_Logo.png';
import darkLogo from '../../assets/images/jlrdarklogo.png';
import TimeIcon from '../../assets/images/TimeIcon.png';
import DarkTheme from '../../assets/images/DarkTheme.png';
import LightTheme from '../../assets/images/LightTheme.png';
import { DARK_MODE, LIGHT_MODE } from '../../constants';
import moment from 'moment';
import UserProfile from '../UserProfile/UserProfile';
import styles from './Header.module.scss';
import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { toggleTheme } from '../../redux/actionCreators/theme';
import { NightsStayRounded, PersonOutline, WbSunnyRounded } from '@mui/icons-material';
import MESIcon from '../../assets/icons/MESIcon';
import { useResolutionScale } from '../../hooks';

const formatTimer = (totalSeconds) => {
	const h = Math.floor(totalSeconds / 3600);
	const m = Math.floor((totalSeconds % 3600) / 60);
	const s = totalSeconds % 60;
	const pad = (n) => String(n).padStart(2, '0');
	return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

const mapStateToProps = (state) => {
	return {
		user: state.user,
		themeMode: state.theme.themeMode,
		cycleTime: state.user.cycleTime,
		receiveTs: state.station.receiveTs,
	};
};

const mapDispatchToProps = (dispatch) => ({
	toggleTheme: (themeMode) => dispatch(toggleTheme(themeMode)),
});

const CssButton = styled(Button)(({ themeMode }) => ({
	width: '3.5vh',
	height: '3.5vh',
	minWidth: '3.5vh',
	background: themeMode === DARK_MODE ? '#2B2E33' : '#E1E1E1',
	boxShadow: '0 0 4px 1px rgba(0, 0, 0, 0.16)',
	borderRadius: '8px',
	padding: 0,
	color: themeMode === DARK_MODE ? '#E1E1E1' : '#17201C',
	'&:hover': {
		background: themeMode === DARK_MODE ? '#3a3d42' : '#dcdcdc',
	},
}));

export const Header = (props) => {
	const { user, themeMode, toggleTheme, cycleTime, receiveTs } = props;
	const [time, setTime] = useState(moment());
	const [elapsed, setElapsed] = useState(0);
	const [showProfile, setShowProfile] = useState(false);
	const profileRef = useRef(null);

	const handleToggleTheme = () => {
		const mode = themeMode === DARK_MODE ? LIGHT_MODE : DARK_MODE;
		toggleTheme(mode);
	};

	useEffect(() => {
		const timeInterval = setInterval(() => {
			setTime(moment());
		}, 1000);
		return () => clearInterval(timeInterval);
	}, []);

	useEffect(() => {
		if (!receiveTs) { setElapsed(0); return; }
		const tick = () => setElapsed(Math.floor((Date.now() - new Date(receiveTs).getTime()) / 1000));
		tick();
		const id = setInterval(tick, 1000);
		return () => clearInterval(id);
	}, [receiveTs]);
	const { scaleValue } = useResolutionScale();
	const iconSize = scaleValue(28);

	const getThemeIcon = () => {
		switch (themeMode) {
			case 'dark':
				return <NightsStayRounded />;
			default:
				return <WbSunnyRounded />;
		}
	};

	return (
		<div className={styles.headerContainer}>
			<img
				className={styles.logo}
				src={themeMode === DARK_MODE ? darkLogo : logo}
				alt="Tata Motors"
			/>

			<div className={styles.ipmsContainer}>
				<Typography className={styles.plantLineAndStation}>
					{[user.plant, user.line, user.station].filter(Boolean).join(' / ')}
				</Typography>

				<IconButton
					onClick={handleToggleTheme}
					className={styles.ThemeIcons}
					data-testid="button-theme-switcher"
					sx={{
						color: 'var(--mui-text-secondary)',
						'& .MuiSvgIcon-root': {
							fontSize: iconSize,
						},
					}}
				>
					{getThemeIcon()}
				</IconButton>

				<div className={styles.timeDisplay}>
					<div className={styles.TimeStyle}>
						<img src={TimeIcon} />
					</div>
					<div className={styles.timeTextContainer}>
						<Typography className={styles.timeText}>
							{time.format('DD-MM-YYYY')}
						</Typography>
						<Typography className={styles.timeText}>
							{time.format('hh:mm:ss A')}
						</Typography>
					</div>
				</div>

				{receiveTs && (
					<div className={`${styles.cycleTimeBox} ${
						!cycleTime
							? styles.cycleTimeGray
							: elapsed >= cycleTime
							? styles.cycleTimeRed
							: styles.cycleTimeGreen
					}`}>
						<Typography className={styles.cycleTimeLabel}>CT</Typography>
						<Typography className={styles.cycleTimeValue}>
							{!cycleTime
								? 'N/A'
								: elapsed >= cycleTime
								? `+${formatTimer(elapsed - cycleTime)}`
								: formatTimer(cycleTime - elapsed)
							}
						</Typography>
					</div>
				)}

				<IconButton
					className={styles.userProfileButton}
					onClick={() => setShowProfile(true)}
					ref={profileRef}
				>
					<PersonOutline className={styles.iconLogo} />
				</IconButton>

				<div className={styles.mesContainer}>
					<MESIcon
						cls1={styles.cls1}
						cls2={styles.cls2}
						cls3={styles.cls3}
						className={styles.mesImage}
					/>
				</div>
			</div>

			<UserProfile
				open={showProfile}
				anchorEl={profileRef.current}
				handleClose={() => setShowProfile(false)}
				user={props.user}
				updateUser={props.updateUser}
				resetFilterTable={props.resetFilterTable}
				updateLastLineItem={props.updateLastLineItem}
			/>
		</div>
	);
};

Header.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
